import { Editor } from 'grapesjs';
import { facTwoColumns } from '@qualifio/ui-commons';
import { EditorComponentDefinition } from '../types';
import { Toolbar } from '../../utils';

export const twoColumnsComponentDefinition: EditorComponentDefinition = {
  id: 'twoColumns',
  icon: facTwoColumns,
  category: 'Basic',
  getLabel: ({ t }) => t('editor.component.two-columns'),
  component: TwoColumnsComponent,
};

export function TwoColumnsComponent(editor: Editor) {
  const CLASSNAME = 'qlfeditor-columns';

  editor.DomComponents.addType(twoColumnsComponentDefinition.id, {
    isComponent: (el: HTMLElement) => {
      return el.tagName === 'DIV' && el.classList.contains(`${CLASSNAME}--2columns`);
    },
    model: {
      defaults: {
        tagName: 'div',
        category: 'Basic',
        components: [
          {
            type: 'column',
            removable: false,
            copyable: false,
            draggable: false,
            selectable: true,
            hoverable: false,
          },
          {
            type: 'column',
            removable: false,
            copyable: false,
            draggable: false,
            selectable: true,
            hoverable: false,
          },
        ],
        attributes: {
          class: `${CLASSNAME} ${CLASSNAME}--2columns`,
        },
        droppable: false,
        draggable: '[data-gjs-type=wrapper], [data-gjs-type=column]',
        traits: [],
      },
      initToolbar: Toolbar,
    },
  });
}
